import { render, staticRenderFns } from "./ChangeUserPassword.vue?vue&type=template&id=918f49d2&scoped=true"
import script from "./ChangeUserPassword.vue?vue&type=script&lang=ts"
export * from "./ChangeUserPassword.vue?vue&type=script&lang=ts"
import style0 from "./ChangeUserPassword.vue?vue&type=style&index=0&id=918f49d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918f49d2",
  null
  
)

export default component.exports